import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@mui/material'

const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0()

  const handleLogin = async (): Promise<void> => {
    await loginWithRedirect({
      appState: {
        returnTo: '/user',
      },
      authorizationParams: {
        prompt: 'login',
      },
    })
  }

  return (
    <Button
      variant='contained'
      onClick={() => { void handleLogin() }}
    >
      Log In
    </Button>
  )
}

export default LoginButton
